import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { QueryBuilder } from "../utils/queryBuilder";

export const getPartnersPaginated = ({ churchId, page, pageSize, queries }) => {
  const queryBuilder = new QueryBuilder();

  queryBuilder.pagination(page, pageSize);

  if (queries.filter) {
    queryBuilder.filter(queries.filter);
  }

  if (queries.search) {
    queryBuilder.search(queries.search);
  }

  if (queries.sort) {
    queryBuilder.sort(queries.sort);
  }

  const queryString = queryBuilder.build();

  return axios.get(`/churches/${churchId}/partners-paginated${queryString}`);
};

export const usePartnersPaginated = ({
  churchId,
  page,
  pageSize,
  queries = {},
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["partners", page, pageSize, churchId, JSON.stringify(queries)],
    queryFn: () => getPartnersPaginated({ churchId, page, pageSize, queries })
  });
};
